var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Play_Store_badge_EN",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.684,
    height: 44.464,
    viewBox: "0 0 150.684 44.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M145.1,44.464H5.583A5.586,5.586,0,0,1,0,38.906V5.558A5.579,5.579,0,0,1,5.583,0H145.1a5.581,5.581,0,0,1,5.583,5.558V38.906A5.588,5.588,0,0,1,145.1,44.464Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1687.823,278.488a3.383,3.383,0,0,1-2.525-1.045,3.559,3.559,0,0,1-1.02-2.55,3.48,3.48,0,0,1,1.02-2.548,3.373,3.373,0,0,1,2.523-1.045,3.418,3.418,0,0,1,2.525,1.045,3.691,3.691,0,0,1,0,5.1A3.355,3.355,0,0,1,1687.823,278.488Zm-29.941,0a3.508,3.508,0,0,1-2.536-1.031,3.593,3.593,0,0,1,2.536-6.154,3.535,3.535,0,0,1,1.417.294,2.866,2.866,0,0,1,1.078.771l.066.08-.751.737-.078-.091a2.135,2.135,0,0,0-1.744-.751,2.41,2.41,0,0,0-1.738.71,2.695,2.695,0,0,0,0,3.692,2.541,2.541,0,0,0,3.523,0,1.921,1.921,0,0,0,.51-1.156h-2.409v-1.037h3.443l.014.094a3.811,3.811,0,0,1,.05.521,3.121,3.121,0,0,1-.859,2.3A3.354,3.354,0,0,1,1657.882,278.488Zm39.81-.147h-1.062l-3.252-5.2.028.937v4.263h-1.062V271.45h1.211l.033.053,3.058,4.9-.028-.934v-4.02h1.073Zm-17.847,0h-1.076v-5.855H1676.9V271.45h4.8v1.037h-1.866v5.855Zm-3.817,0h-1.073V271.45h1.073Zm-6.029,0h-1.073v-5.855h-1.866V271.45h4.8v1.037H1670Zm-3.618-.011h-4.114v-6.88h4.114v1.037h-3.038v1.891h2.741V275.4h-2.741v1.891h3.038Zm19.7-1.6a2.374,2.374,0,0,0,1.738.721,2.313,2.313,0,0,0,1.738-.721,2.732,2.732,0,0,0,0-3.67,2.378,2.378,0,0,0-1.738-.721,2.3,2.3,0,0,0-1.735.721,2.735,2.735,0,0,0-.006,3.67Z",
    transform: "translate(-1608.442 -263.779)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1676.788,688.25a4.729,4.729,0,1,0,4.743,4.729A4.655,4.655,0,0,0,1676.788,688.25Zm0,7.584a2.874,2.874,0,1,1,2.667-2.866A2.737,2.737,0,0,1,1676.788,695.835Zm-10.348-7.584a4.729,4.729,0,1,0,4.743,4.729A4.655,4.655,0,0,0,1666.44,688.25Zm0,7.584a2.874,2.874,0,1,1,2.667-2.866A2.737,2.737,0,0,1,1666.44,695.835Zm-12.313-6.14v2h4.8a4.218,4.218,0,0,1-1.087,2.52,4.9,4.9,0,0,1-3.706,1.469,5.337,5.337,0,0,1,0-10.672,5.128,5.128,0,0,1,3.617,1.433l1.419-1.419a6.98,6.98,0,0,0-5.026-2.026,7.338,7.338,0,1,0,0,14.675,6.717,6.717,0,0,0,5.125-2.062,6.641,6.641,0,0,0,1.741-4.693,6.2,6.2,0,0,0-.111-1.247h-6.781S1654.126,689.695,1654.126,689.695Zm50.366,1.558a4.395,4.395,0,0,0-4.05-3.013,4.493,4.493,0,0,0-4.458,4.729,4.622,4.622,0,0,0,4.693,4.729,4.694,4.694,0,0,0,3.939-2.1l-1.605-1.076a2.689,2.689,0,0,1-2.323,1.308,2.415,2.415,0,0,1-2.3-1.433l6.323-2.62S1704.492,691.252,1704.492,691.252Zm-6.448,1.58a2.6,2.6,0,0,1,2.47-2.755,1.823,1.823,0,0,1,1.755,1Zm-5.137,4.582h2.076V683.521h-2.076Zm-3.41-8.114h-.075a3.275,3.275,0,0,0-2.495-1.062,4.729,4.729,0,0,0,0,9.45,3.266,3.266,0,0,0,2.495-1.076h.075v.679c0,1.8-.965,2.778-2.52,2.778a2.622,2.622,0,0,1-2.384-1.68l-1.8.754a4.514,4.514,0,0,0,4.186,2.791c2.434,0,4.5-1.433,4.5-4.929v-8.485h-1.963v.779Zm-2.384,6.534a2.875,2.875,0,0,1,0-5.73,2.658,2.658,0,0,1,2.52,2.877A2.625,2.625,0,0,1,1687.114,695.835Zm27.1-12.313h-4.965v13.894h2.076v-5.261h2.891a4.323,4.323,0,1,0,0-8.632Zm.061,6.692h-2.952v-4.768h2.952a2.384,2.384,0,1,1,0,4.768Zm12.821-1.988a3.91,3.91,0,0,0-3.706,2.123l1.841.765a1.974,1.974,0,0,1,1.891-1.026,2.005,2.005,0,0,1,2.187,1.791v.147a4.653,4.653,0,0,0-2.162-.532c-1.988,0-4,1.087-4,3.124a3.211,3.211,0,0,0,3.446,3.063,2.922,2.922,0,0,0,2.642-1.358h.075V697.4h2v-5.322C1731.306,689.6,1729.465,688.225,1727.1,688.225Zm-.26,7.609c-.679,0-1.63-.333-1.63-1.186,0-1.076,1.186-1.483,2.2-1.483a3.6,3.6,0,0,1,1.891.468A2.5,2.5,0,0,1,1726.835,695.835Zm11.773-7.313-2.384,6.026h-.075l-2.47-6.026h-2.234l3.706,8.424-2.112,4.682h2.162l5.7-13.106Zm-18.689,8.893h2.076V683.521h-2.076Z",
    transform: "translate(-1601.052 -664.068)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M400.607,299.475a2.252,2.252,0,0,0-.507,1.569v24.58a2.143,2.143,0,0,0,.518,1.555l.086.075,13.772-13.772v-.308L400.693,299.4Z",
    transform: "translate(-389.009 -291.102)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M922.893,640.008l-4.593-4.593v-.322l4.593-4.593.1.061,5.433,3.088c1.555.876,1.555,2.323,0,3.21l-5.433,3.088Z",
    transform: "translate(-892.844 -613.023)",
    fill: "#e0e0e0",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M436.951,806.693,432.258,802,418.4,815.858a1.819,1.819,0,0,0,2.309.075l16.242-9.239",
    transform: "translate(-406.802 -779.77)",
    fill: "#666",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M436.951,296.078l-16.242-9.225a1.8,1.8,0,0,0-2.309.075l13.858,13.844Z",
    transform: "translate(-406.802 -278.539)",
    fill: "#afafaf",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M437.24,967.7l-16.131,9.164a1.831,1.831,0,0,1-2.223.011l-.086.086.086.075a1.835,1.835,0,0,0,2.223-.011l16.242-9.225Z",
    transform: "translate(-407.19 -940.875)",
    fillRule: "evenodd",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1089.047,803.444l-5.547,3.149.1.1,5.433-3.088a1.947,1.947,0,0,0,1.161-1.6A2,2,0,0,1,1089.047,803.444Z",
    transform: "translate(-1053.465 -779.77)",
    fillRule: "evenodd",
    opacity: 0.12
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M402.916,286.843l21.675,12.313a2.043,2.043,0,0,1,1.161,1.444A1.947,1.947,0,0,0,424.591,299l-21.675-12.313c-1.555-.89-2.816-.147-2.816,1.63v.161C400.1,286.694,401.361,285.965,402.916,286.843Z",
    transform: "translate(-389.009 -278.369)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.a3e994949cdc0a22a02f3a4b32456428.svg";
export { ForwardRef as ReactComponent };